








































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { IUser } from '@/interfaces/user';
import { IGroup } from '../../interfaces/group';
import CreateUserMutation from '@/graphql/mutations/createUser.gql';
import request from '@/graphql/request';

@Component({
  components: {
  },
})
export default class GroupAddGroup extends Vue {
  @Prop({ required: true })
  public group!: IGroup;

  public username: string = '';
  public email: string = '';
  public password: string = '';
  public role: 'user' | 'admin' | null = null;

  

  public async createUser() {
    const { data, errors } = await request(CreateUserMutation, {
      username: this.username,
      email: this.email,
      password: this.password,
      role: this.role,
      groupId: this.group.id,
    });

    if (!errors || !errors.length) {
      this.$router.push(`/group/${this.group.id}/users`);
      this.$emit('refreshGroup');
    }
  }
}
